import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { CampEntry } from '../../helpers/propTypes';

class View extends PureComponent {
  renderPcRentals() {
    const {
      isAllPcRental, AvailableCampRentals, campRentals, pcRentalDiscription, pcType, pcRental,
    } = this.props.displays.pcRental;

    if (isAllPcRental) {
      return null;
    }
    if (AvailableCampRentals) {
      return campRentals.filter((x) => !_.isEmpty(x)).map((x) => {
        return (
          <React.Fragment key={x.name}>
            <tr>
              <th>
                {x.name}
                レンタルの有無
              </th>
              <td><span>{x.use_rental}</span></td>
            </tr>
            {x.use_rental === 'ご自身のPCを使用' && (
            <tr>
              <th>
                {x.name}
                の種類
              </th>
              <td><span>{x.pc_type}</span></td>
            </tr>
            )}
          </React.Fragment>
        );
      });
    }
    return (
    // TODO: iPadレンタルのテスト
      <>
        <tr>
          <th>PCレンタル</th>
          <td><span>{pcRentalDiscription}</span></td>
        </tr>
        {pcType !== null && !pcRental && (
        <tr>
          <th>PCの種類</th>
          <td><span>{pcType.name}</span></td>
        </tr>
        )}
      </>
    );
  }

  render() {
    const {
      displays, isFree,
    } = this.props;
    const getIsEmpty = (x) => {
      return x === undefined || x === null || x === '' ? 'empty' : undefined;
    };
    return (
      <table className="responsive">
        <thead>
          <tr>
            <th colSpan="2">キャンプ情報</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>参加する日程</th>
            <td><span>{displays.plan}</span></td>
          </tr>
          <tr>
            <th>宿泊 / 通いプラン</th>
            <td><span>{displays.stayplan}</span></td>
          </tr>
          {getIsEmpty(displays.meeting_time) !== 'empty' && (
            <tr>
              <th>集合時間</th>
              <td><span>{displays.meeting_time}</span></td>
            </tr>
          )}
          <tr>
            <th>コース</th>
            <td><span>{displays.course}</span></td>
          </tr>
          {this.renderPcRentals()}
          <tr>
            <th>同室・同チーム希望</th>
            <td><span className={getIsEmpty(displays.grouping_comment)}>{displays.grouping_comment}</span></td>
          </tr>
          <tr>
            <th>パソコン経験</th>
            <td><span className={getIsEmpty(displays.experience)}>{displays.experience}</span></td>
          </tr>
          {!isFree && (
            <tr>
              <th>お支払い方法</th>
              <td><span>{displays.payment}</span></td>
            </tr>
          )}
          <tr>
            <th>キャンプを何で知りましたか？</th>
            <td><span>{displays.learned_reason}</span></td>
          </tr>
          <tr>
            <th>質問・要望</th>
            <td><span className={getIsEmpty(displays.comment)}>{displays.comment}</span></td>
          </tr>
        </tbody>
      </table>
    );
  }
}

View.propTypes = {
  displays: CampEntry.isRequired,
  isFree: PropTypes.bool.isRequired,
};

export default View;
